import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { Store } from '@ngrx/store';
import { map } from 'rxjs/operators';
import { AppState } from '../app-state/models/app-state';
import { UserDataService } from './user-data.service';

@Injectable()
export class ServiceCardAuthGuard implements CanActivate {
  constructor(
    private userService: UserDataService,
    private router: Router,
    private store: Store<AppState>
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    return this.store
      .select((s) => s.currentUserState.currentUser)
      .pipe(
        map((user) => {
          console.log('ServiceCardAuthGuard#canActivate called');
          const allowAccess = user && user.userType === 'VerifiedIndividual';
          console.log(allowAccess);

          if (!allowAccess) {
            this.router.navigate(['/']);
          }
          return allowAccess;
        })
      );
  }
}
